module.exports = __webpack_public_path__ + "static/media/umrah-one-box.d49041d7.png";